import { render, staticRenderFns } from "./tabs-basic.vue?vue&type=template&id=00ee5972"
import script from "./tabs-basic.vue?vue&type=script&lang=js"
export * from "./tabs-basic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports